import React from "react";
import classNames from "classnames";

import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {
    cardCoverImageHorizontal,
    cardCoverImageVertical,
    cardCoverImageVerticalLong,
    figcaptionStyle,
    figureStyle,
    iconMargin,
    imageResponsive,
    textWrapperStyle
} from "./CardCoverWithText.module.css";

export type CardCoverRatioVariants = "horizontal" | "vertical" | "verticalLong";

export interface ICardCoverImageWithTextProps {
    image: string;
    title: string;
    text?: string;
    ratioVariant?: CardCoverRatioVariants;
    className?: string;
}

const getRatioVariant = (variant: CardCoverRatioVariants) => {
    switch (variant) {
        case "horizontal":
            return cardCoverImageHorizontal;
        case "vertical":
            return cardCoverImageVertical;
        case "verticalLong":
            return cardCoverImageVerticalLong;
    }
};

export const CardCoverImageWithText = (props: ICardCoverImageWithTextProps) => {
    const imageCN = classNames(props.className, props.ratioVariant && getRatioVariant(props.ratioVariant), imageResponsive);
    const figcaptionCN = classNames(props.className, figcaptionStyle);

    return (
        <figure className={figureStyle}>
            <img className={imageCN} src={props.image} alt={props.title} />
            <figcaption className={figcaptionCN}>
                <Text variant="headline_3">{props.title}</Text>
                {props.text ? (
                    <div className={textWrapperStyle}>
                        <Text variant="body_copy_2">{props.text}</Text>
                        <ChevronRightIcon className={iconMargin} size="2.4" wrapperSize="4.8" wrapperColor="var(--colors-primary)" />
                    </div>
                ) : null}
            </figcaption>
        </figure>
    );
};
import React from "react";
import classNames from "classnames";

import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {
    cardCoverImageHorizontal,
    cardCoverImageVertical,
    cardCoverImageVerticalLong,
    figcaptionStyle,
    figureStyle,
    iconMargin,
    imageResponsive,
    textWrapperStyle
} from "./CardCoverWithText.module.css";

export type CardCoverRatioVariants = "horizontal" | "vertical" | "verticalLong";

export interface ICardCoverImageWithTextProps {
    image: string;
    title: string;
    text?: string;
    ratioVariant?: CardCoverRatioVariants;
    className?: string;
}

const getRatioVariant = (variant: CardCoverRatioVariants) => {
    switch (variant) {
        case "horizontal":
            return cardCoverImageHorizontal;
        case "vertical":
            return cardCoverImageVertical;
        case "verticalLong":
            return cardCoverImageVerticalLong;
    }
};

export const CardCoverImageWithText = (props: ICardCoverImageWithTextProps) => {
    const imageCN = classNames(props.className, props.ratioVariant && getRatioVariant(props.ratioVariant), imageResponsive);
    const figcaptionCN = classNames(props.className, figcaptionStyle);

    return (
        <figure className={figureStyle}>
            <img className={imageCN} src={props.image} alt={props.title} />
            <figcaption className={figcaptionCN}>
                <Text variant="headline_3">{props.title}</Text>
                {props.text ? (
                    <div className={textWrapperStyle}>
                        <Text variant="body_copy_2">{props.text}</Text>
                        <ChevronRightIcon className={iconMargin} size="2.4" wrapperSize="4.8" wrapperColor="var(--colors-primary)" />
                    </div>
                ) : null}
            </figcaption>
        </figure>
    );
};
